
export const playerActionTypes = {
	/**
	 * Player (analytics-related) action types
	 */
	PLAYER_PLAY_LOAD            : "PLAYER_PLAY_LOAD",
	PLAYER_PLAY_RESUME          : "PLAYER_PLAY_RESUME",
	PLAYER_PLAY_PAUSE           : "PLAYER_PLAY_PAUSE",
	PLAYER_SKIP_FORWARD         : "PLAYER_SKIP_FORWARD",
	PLAYER_SKIP_BACKWARD        : "PLAYER_SKIP_BACKWARD",
	PLAYER_VOLUME_CHANGE        : "PLAYER_VOLUME_CHANGE",
	PLAYER_SPEED_CHANGE         : "PLAYER_SPEED_CHANGE",
	PLAYER_FULL_VIEW_LOAD       : "PLAYER_FULL_VIEW_LOAD",
	PLAYER_FULL_VIEW_EXIT       : "PLAYER_FULL_VIEW_EXIT",
	PLAYER_GIST_SHOW            : "PLAYER_GIST_SHOW",
	PLAYER_GIST_HIDE            : "PLAYER_GIST_HIDE",
	PLAYER_GIST_LOGO_REDIRECT   : "PLAYER_GIST_LOGO_REDIRECT",
	PLAYER_GIST_WORD_PLAY       : "PLAYER_GIST_WORD_PLAY",
	PLAYER_GIST_HINT_SHOW       : "PLAYER_GIST_HINT_SHOW",
	PLAYER_CHAPTER_CHANGE       : "PLAYER_CHAPTER_CHANGE",
	PLAYER_TOC_VIEW_LOAD        : "PLAYER_TOC_VIEW_LOAD",
	PLAYER_TOC_VIEW_TO_CHAPTER  : "PLAYER_TOC_VIEW_TO_CHAPTER",
	PLAYER_TOC_VIEW_CLOSE       : "PLAYER_TOC_VIEW_CLOSE",
	PLAYER_SEARCH_OPEN			: "PLAYER_SEARCH_OPEN",
	PLAYER_SEARCH_PERFORM		: "PLAYER_SEARCH_PERFORM",
	PLAYER_SEARCH_CLOSE			: "PLAYER_SEARCH_CLOSE",
};